import { useState, useCallback } from 'react';
import { printerService, PrinterStatus } from '@/services/printerService';

export function usePrinter(ip?: string, tipo?: string) {
  const [loading, setLoading] = useState(false);
  const [status, setStatus] = useState<PrinterStatus | null>(null);
  const [error, setError] = useState<string | null>(null);

  const testarConexao = useCallback(async () => {
    if (!ip || !tipo) return false;
    
    setLoading(true);
    setError(null);
    
    try {
      const isConnected = await printerService.testarConexao(ip, tipo);
      if (!isConnected) {
        setError('Não foi possível conectar à impressora na rede local.');
      }
      return isConnected;
    } catch (err: any) {
      setError(err.message || 'Erro inesperado na conexão');
      return false;
    } finally {
      setLoading(false);
    }
  }, [ip, tipo]);

  const atualizarStatus = useCallback(async () => {
    if (!ip || !tipo) return;
    
    try {
      const newStatus = await printerService.getStatus(ip, tipo);
      setStatus(newStatus);
    } catch (err: any) {
      setError(err.message);
    }
  }, [ip, tipo]);

  const enviarGCode = useCallback(async (gcode: string) => {
    if (!ip) return false;
    setLoading(true);
    try {
      return await printerService.enviarGCode(ip, gcode);
    } catch (err: any) {
      setError(err.message);
      return false;
    } finally {
      setLoading(false);
    }
  }, [ip]);

  return {
    testarConexao,
    atualizarStatus,
    enviarGCode,
    status,
    loading,
    error
  };
}
